import { NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import InstrumentMappingsLookup from '../Models/InstrumentMappingLookupModel';
import InstrumentMappingSearchCriteria from '../Models/InstrumentMappingSearchCriteraModel'
import { Data } from '@singularsystems/neo-core';
import RunInterceptionComponentVM from '../../../Common/Components/Interception/RunInterceptionComponentVM';
import AssignInstrumentComponentVM from '../components/AssignInstrumentComponentVM';
import { TextConstants } from '../../../Common/TextConstants';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import { reaction } from 'mobx';
import InstrumentMappingUpdate from '../Models/InstrumentMappingUpdate';

@NeoModel
export default class InstrumentMappingVM extends Views.ViewModelBase {

    constructor(
        public instrumentMappingApiClient = AppService.get(Types.ApiClients.InstrumentMappingApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService)) {
        super(taskRunner);
    }

    public instrumentMappingUpdateList: InstrumentMappingsLookup[] = [];
    public showAssignInstrumentComponent: boolean = false;
    public instrumentMappingCriteria = new InstrumentMappingSearchCriteria();
    public instrumentMappingUpdate = new InstrumentMappingUpdate();
    public assignInstrumentVM = new AssignInstrumentComponentVM();
    public runInterceptionVM = new RunInterceptionComponentVM();

    public pageManager = new Data.PageManager(this.instrumentMappingCriteria, InstrumentMappingsLookup, this.instrumentMappingApiClient.getPagedInstrumentMappings, {
        pageSize: 10,
        sortAscending: false,
        fetchInitial: true,
        initialTaskRunner: this.taskRunner,
    });

    public async initialise() {
        reaction(() => this.instrumentMappingCriteria.searchCriteria, () => this.pageManager.refreshData(), {fireImmediately: false, delay: 650 });
        this.populateInterceptionDropDownList();
    }

    public async backToInstrumentMapping() {
        this.instrumentMappingUpdateList = [];
        this.taskRunner.run(async () => {await this.assignInstrumentVM.pageManager.refreshData()});
        this.instrumentMappingCriteria.meta.searchCriteria.value = "";
        await this.pageManager.refreshData().finally(()=> {
            this.showAssignInstrumentComponent = !this.showAssignInstrumentComponent;
        });
    }

    public displayAssignInstrumentComponent() {
        this.showAssignInstrumentComponent = !this.showAssignInstrumentComponent;
    }

    public async populateInterceptionDropDownList() {
        await this.runInterceptionVM.initialise();
    }

    public populateMappedObject(selectedInstrumentMappingValues: InstrumentMappingsLookup) {
        var existingObject = this.instrumentMappingUpdateList.find(c => c.genericInstrumentMappingId === selectedInstrumentMappingValues.genericInstrumentMappingId);

        if (existingObject) {
            this.instrumentMappingUpdateList.remove(existingObject);
        }
        else {
            this.instrumentMappingUpdateList.push(selectedInstrumentMappingValues);
        }
    }

    public async updateInstrumentMapping() {
        this.instrumentMappingUpdate.selectedInstrument = this.assignInstrumentVM.selectedInstrument;
        this.instrumentMappingUpdate.mappings = this.instrumentMappingUpdateList;

        var response = await this.taskRunner.run(() => this.instrumentMappingApiClient.updateInstrumentMapping(this.instrumentMappingUpdate.toJSObject()));
        if (response.data.success) {
            NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.SuccessfulInstrumentMappingUpdate, NotificationDuration.Standard);
            this.backToInstrumentMapping();
        }
        else {
            NotifyUtils.add(TextConstants.Titles.Error, TextConstants.Notifications.FailedSubmission ,"danger" as any, NotificationDuration.Long);
            this.backToInstrumentMapping();
        }
    }

    public async clearSearch() {
        this.instrumentMappingCriteria.meta.searchCriteria.value = "";
        this.taskRunner.run(async () => {await this.pageManager.refreshData()});
    }

    public async onAssignInstrumentSearch() {
        this.taskRunner.run(async () => {await this.assignInstrumentVM.pageManager.refreshData()});
    }
}


